// Angular import
import { Component, Input } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';

// project import
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { KeycloakService } from 'keycloak-angular';
import { UserKeycloak } from 'src/app/shared/model/user.keycloak';
import { KeycloakProfile } from 'keycloak-js';
import { ruoli } from 'src/app/shared/data/ruoli';
import { faCircleUser, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/angular-fontawesome/types';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss']
})
export class VerticalMenuComponent {

  // public props
  @Input() menus!: NavigationItem[];
  user: UserKeycloak|undefined;
  faUser: IconProp=faCircleUser;
  faLogout: IconProp=faPowerOff
  // Constructor
  constructor(
    private location: Location,
    private locationStrategy: LocationStrategy,
    private keycloakService: KeycloakService
  ) {
    
  }
  async ngOnInit(){
    const ruoliKey=await this.keycloakService.getUserRoles()
    this.user={
    profile:await this.keycloakService.loadUserProfile(),
    role:ruoliKey,
    ruoloGenomica:ruoliKey.filter(r=>ruoli.includes(r))[0]
   }
  }
  // public method
  fireOutClick() {
    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent?.parentElement?.parentElement;
      const last_parent = up_parent?.parentElement;
      if (parent?.classList.contains('coded-hasmenu')) {
        parent.classList.add('coded-trigger');
        parent.classList.add('active');
      } else if (up_parent?.classList.contains('coded-hasmenu')) {
        up_parent.classList.add('coded-trigger');
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('coded-hasmenu')) {
        last_parent.classList.add('coded-trigger');
        last_parent.classList.add('active');
      }
    }
  }
  logOut() {
    this.keycloakService.logout()
    }
  accountList = [
    {
      icon: 'ti ti-user',
      title: 'My Account'
    },
    {
      icon: 'ti ti-settings',
      title: 'Settings'
    },
    {
      icon: 'ti ti-lock',
      title: 'Lock Screen'
    },
    {
      icon: 'ti ti-power',
      title: 'Logout'
    }
  ];
}
